import { buildValueMap } from "./utils";

export const StatusDef = {
    Active: { value: 1, label: "Active" },
    Inactive: { value: 2, label: "Inactive" }
};

export const AccountStatusDef = {
    Normal: { value: 1, label: "Normal" },
    Inactive: { value: 2, label: "Inactive" }
};

export const InventoryStatusDef = {
    Available: { value: 1, label: "Available" },
    NotAvailable: { value: 2, label: "Not Available" }
};

export const ReconciliationStatusDef = {
    Reconciled: { value: 1, label: "Reconciled" },
    Unreconciled: { value: 2, label: "Unreconciled" }
};

export const TransactionStatusDef = {
    NotReviewed: { value: 1, label: "Not Reviewed" },
    Reviewed: { value: 2, label: "Reviewed" }
};

export const Status = buildValueMap(StatusDef);
export const AccountStatus = buildValueMap(AccountStatusDef);
export const InventoryStatus = buildValueMap(InventoryStatusDef);
export const ReconciliationStatus = buildValueMap(ReconciliationStatusDef);
export const TransactionStatus = buildValueMap(TransactionStatusDef);
